import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface MountainParallaxProps {
    className?: string
}

const BACK_RIDGE = 'M0 175 L80 140 L150 160 L240 92 L310 130 L380 104 L470 150 L560 70 L640 118 L720 96 L800 138 L880 62 L960 112 L1040 90 L1120 140 L1200 78 L1290 124 L1370 100 L1440 128'
const MID_RIDGE = 'M0 230 L90 196 L170 214 L260 168 L350 206 L430 180 L520 220 L610 160 L700 200 L790 176 L880 214 L970 150 L1060 198 L1150 172 L1240 210 L1330 166 L1440 196'
const FRONT_HILLS = 'M0 290 C120 262 210 250 320 268 C430 286 520 250 640 246 C760 242 840 276 960 272 C1080 268 1180 240 1290 252 C1360 260 1410 272 1440 268'
const CLOSE = ' L1440 320 L0 320 Z'

/* Layered Zagros silhouette; the layers drift at different speeds while scrolling (see .mountain-layer-* in globals.css) */
export const MountainParallax: FC<MountainParallaxProps> = ({ className }): ReactNode => {
    return (
        <div aria-hidden='true' className={cn('pointer-events-none absolute inset-x-0 bottom-0 h-40 sm:h-52 lg:h-64', className)}>
            <svg viewBox='0 0 1440 320' preserveAspectRatio='none' className='mountain-layer-back absolute inset-0 size-full'>
                <path d={BACK_RIDGE + CLOSE} fill='#153829' opacity='0.75' />
                <path d={BACK_RIDGE} fill='none' stroke='#c9a24a' strokeOpacity='0.18' strokeWidth='1.2' vectorEffect='non-scaling-stroke' />
            </svg>

            <svg viewBox='0 0 1440 320' preserveAspectRatio='none' className='mountain-layer-mid absolute inset-0 size-full'>
                <path d={MID_RIDGE + CLOSE} fill='#1c4a35' />
                <path d={MID_RIDGE} fill='none' stroke='#c9a24a' strokeOpacity='0.45' strokeWidth='1.4' vectorEffect='non-scaling-stroke' />
            </svg>

            <svg viewBox='0 0 1440 320' preserveAspectRatio='none' className='absolute inset-0 size-full'>
                <path d={FRONT_HILLS + CLOSE} className='fill-background' />
            </svg>
        </div>
    )
}
